// src/data/services/send-email.service.ts
import axios from "axios";
import { api } from "./api";


type SendEmailParams = {
  from: string;
  to: string;
  subject: string;
  html: string;
};

type createPlayerPayload = {
    _id: string;
    name: string;
    email: string;
    extra: {
      conviteEnviado: boolean;
    }
}

export async function sendEmail({ from, to, subject, html }: SendEmailParams) {
  const MAILGUN_DOMAIN =
    "https://api.mailgun.net/v3/funifier.com/messages";

    const MAILGUN_API_KEY = "3afca8fa99581258c739b88239b401e4-96164d60-521de676";

  const auth = btoa(`api:${MAILGUN_API_KEY}`);

  const params = new URLSearchParams();
  params.append("from", from);
  params.append("to", to);
  params.append("subject", subject);
  params.append("html", html);

  try {
    const response = await axios.post(MAILGUN_DOMAIN, params, {
      headers: {
        Authorization: `Basic ${auth}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error(
      "Erro ao enviar e-mail:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export async function createPlayer (payload: createPlayerPayload){
  try{
    const {data} = await api.post('/player', payload);
    return data;
  }catch (error: any) {
    console.error(
      "Erro ao criar jogador:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export async function listPlayers() {
  try{
    const {data} = await api.get('/player');
    return data;
  }catch (error: any) {
    console.error(
      "Erro ao listar jogadores:",
      error.response?.data || error.message
    );
    throw error;
  }
}
